import { BaseEntity } from '../../../../../shared-utils/repository/entities/base-entity';
import { CardBrandType } from '../../../../../modules/credt-card-clearance/repositories/credit-card-tokens/entities/credit-card-token-entity';

export enum AccountTypeEnum {
  CASH = 'cash',
  CHECK = 'check',
  BANK = 'bank',
  CREDIT_CARD = 'credit_card',
  INCOME = 'income',
  EXPENSE = 'expense',
}

export interface ChartOfAccountsEntity extends BaseEntity {
  id: number;
  accountCode: string;
  accountName: string;
  accountType: AccountTypeEnum;
  creditCardCompany: CardBrandType | null;
  bankName: string | null;
  isActive: boolean;
}

export interface ChartOfAccountsBranchEntity extends BaseEntity {
  id: number;
  accountId: number;
  branchId: number;
}
